// Page validation errors
export const PAGE_TAKEN_ERROR = 'Page name is already taken';
export const PAGE_NAMED_HOME_ERROR = "Page name can't be 'home'";
export const PAGE_NAMED_RSVP_ERROR = "Page name can't be 'rsvp'";
export const PAGE_TITLE_BLANK_ERROR = 'Page name must include at least one letter';

// Standard errors
export const STANDARD_ERROR_MESSAGE = 'Oops! Something went wrong. Please try again later.';
